import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';
// import store filter from store-filter.service
import { StoreFilterService } from 'src/modules/shared/services';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { getDate } from 'date-fns';

interface IAdvanceSearchModalContext {
  header: any;
  title?: string;
  fieldx?: any[];
}
interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}

@Component({
  selector: 'app-advanced-search-modal',
  templateUrl: './advanced-search-modal.component.html',
  styleUrls: ['./advanced-search-modal.component.scss'],
})
export class AdvancedSearchModalComponent {
  @Input() searchName: string = '';
  @Output() advancedSearchEmitter: EventEmitter<any> = new EventEmitter<any>();
  headers: any[] = [];
  @Output() submitSearch = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  fieldx: Array<IHeaders> = [];
  fieldMap = new Map();
  operators = [
    { id: 'cn', name: 'contains' },
    { id: 'nc', name: 'does not contain' },
    { id: 'eq', name: 'equal' },
    { id: 'ne', name: 'not equal' },
    { id: 'lt', name: 'less' },
    { id: 'le', name: 'less or equal' },
    { id: 'gt', name: 'greater' },
    { id: 'ge', name: 'greater or equal' },
    { id: 'bw', name: 'begins with' },
    { id: 'bn', name: 'does not begin with' },
    { id: 'ew', name: 'ends with' },
    { id: 'en', name: 'does not end with' },
  ];

  oldoperators = [
    { id: 'cn', name: 'contains' },
    { id: 'eq', name: 'equal' },
  ];

  groupOperators = [
    { id: 'AND', name: 'AND' },
    { id: 'OR', name: 'OR' },
  ];

  mode = 'date';

  searchFilter = {
    groupOp: 'AND',
    rules: [],
  };
  selectedFilters: any[] = []; // Initialize an array to store selected filters
  selectedFilter: string = '';
  selectForm = new FormControl();

  constructor(
    public modal: SuiModal<IAdvanceSearchModalContext, void, void>,
    private storeFilterService: StoreFilterService,
    private router: Router,
    @Inject(DOCUMENT) private document
  ) {
    this.headers = modal.context.header;
    this.fieldx = modal.context.fieldx || [];
    this.selectForm.setValue(this.headers?.length ? this.headers[0] : '');
    console.log(this.fieldx);
    // console.log(this.modal.context);

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.storeFilterService.setFilter(null);
      }
    });

    this.storeFilterService.filter$.subscribe((value) => {
      console.log('Stored filter:', value);
      if (value) {
        this.fieldx = value.rules;
        this.searchFilter.groupOp = value.groupOp;
      }
    });
  }

  ngOnInit() {
    this.document.body.classList.remove('panel');
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }

  trackByIndex(index: number, value: any) {
    // if (value.type === 'date' && value.data instanceof Date) {
    //   return value.id;
    // } else if (value.type === 'date' && !(value.date instanceof Date)) {
    //   // console.log('date track')
    //   let d = value.data.split('.')[0];
    //   value.data = new Date(d);
    //   return value.id;
    // } else {
    return value.id;
    // }
  }

  changeCondition(value: any) {
    this.searchFilter.groupOp = value.target.value;
    console.log(this.changeCondition, 'this is opeartors');
  }

  setSelectedFilter(ev: any) {
    if (ev && ev.target && ev.target.value) {
      this.selectedFilter = ev.target.value;
    }
  }

  add() {
    console.log('Add function triggered');
    if (this.selectForm.value && this.selectForm.value !== '') {
      console.log('Adding value:', this.selectForm.value);
      const selectedFilter = { ...this.selectForm.value, data: '' };
      this.fieldx.push(selectedFilter);
      console.log('this.fieldx after push:', this.fieldx);
    }
  }

  remove(index) {
    this.fieldx.splice(index, 1);
  }

  setRule(item) {}

  changeOperators(event) {
    if (event.contractorType === null) {
      this.fieldx[event.index].op = 'eq';
    } else {
      this.fieldx[event.index].op = 'regex';
    }
  }

  submit() {
    window.localStorage.setItem('AdSearch', JSON.stringify(this.fieldx));
    const filteredFields = this.fieldx.map((item) => {
      if (item.type === 'date') {
        const date = new Date(item.data);
        console.log(date);
        return {
          field: item.field,
          op: item.op,
          data:
            item.data != null
              ? date.toISOString().split('.')[0].toString()
              : item.data,
        };
      } else if (item.type === 'number') {
        return { field: item.field, op: item.op, data: Number(item.data) };
      } else {
        return { field: item.field, op: item.op, data: item.data };
      }
    });
    const search: any = {
      groupOp: this.searchFilter.groupOp,
      rules: filteredFields,
    };

    this.storeFilterService.setFilter({
      groupOp: this.searchFilter.groupOp,
      rules: this.fieldx,
    });

    this.modal.approve(search);
    console.log(search, 'this is search filter');
  }

  cancel() {
    this.modal.deny(null);
  }
}

export class AdvanceSearchModal extends ComponentModalConfig<
  IAdvanceSearchModalContext,
  void,
  void
> {
  constructor(
    title: string,
    header: any,
    fieldx: [],
    size: ModalSize = ModalSize.Small
  ) {
    super(AdvancedSearchModalComponent, { title, header, fieldx });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
